export const APP_SCIENCE_EMAIL_KEY = 'proposal-frontend__appScienceEmail'
export const GOOGLE_SHEETS_LINK_KEY = 'proposal-frontend__googleSheetsLink'
export const RUB_GOOGLE_SHEETS_LINK_KEY = 'proposal-frontend__rubGoogleSheetsLink'
export const PDF_LINK_KEY = 'proposal-frontend__pdfLink'
export const DOC_LINK_KEY = 'proposal-frontend__docLink'
export const BILL_LINK_KEY = 'proposal-frontend__billLink'
export const SPECIFICATION_PDF_LINK_KEY = 'proposal-frontend__specificationPdfLink'
export const SPECIFICATION_DOC_LINK_KEY = 'proposal-frontend__specificationDocLink'
